/* eslint-disable */
<template>
  <div id="app">
    <menubar @menubar-loading="menubarReady = false" @menubar-ready="menubarReady = true" />
    <!-- <div class="app has-tab-menu" v-if="tabs[currentRoute] && !tabs[currentRoute].find((t) => t.hidden)"> -->
    <div class="app has-tab-menu" v-if="tabs[currentRoute] && tabs[currentRoute].filter(f => !f.hidden).length > 0">
      <div class="header">
        <menutabs :state="{ tabs: tabs[currentRoute] }" :isSuperUser="false" :tab-selected="tabSelected" @tab-select="UpdateSelectedView" />
        <!-- <menutabs :state="{ tabs: tabs[currentRoute] }" :isSuperUser="isSuperUser" :tab-selected="tabSelected" @tab-select="UpdateSelectedView" /> -->
      </div>
    </div>
    <component
      v-if="tabSelected && tabSelected.view"
      :is="tabSelected.view"
      class="component-container"
      v-bind:class="{ 'full-height': tabs[currentRoute] ? tabs[currentRoute].filter(f => !f.hidden).length == 0 : true }"
    />
    <!-- v-bind:class="{ 'full-height': tabs[currentRoute].find((t) => t.hidden) }" -->
    <dropdowncontainer :state="tooltipState" ref="tooltip" />
    <div class="popupmessage-container">
      <popupmessage v-for="(popupmessage, imessage) in popupmessages" :message="popupmessage" :key="imessage + 'i'" />
    </div>
    <div>
      <dropdowncontainer v-for="(popup, indexP) in genericPopups" :state="popup" :key="indexP + 'p'" @on-close="CheckDropdownContainers" />
    </div>
    <div>
      <popupalert v-for="(popupalert, ialert) in popupalerts" :message="popupalert" :key="ialert + 't'" />
    </div>
  </div>
</template>

<script>
import dropdowncontainer from "./components/uicomponents/dropdowncontainer";
import popupmessage from "./components/uicomponents/popupmessage.vue";
import popupalert from "./components/uicomponents/popupalert.vue";
import menubar from "./components/MenuBar";
import VueEventBus from "./vue-event-bus";
import { mapState, mapGetters } from "vuex";
export default {
  name: "App",
  components: {
    dropdowncontainer,
    menubar,
    popupmessage,
    popupalert,
  },
  data() {
    return {
      tooltipState: {
        toggled: false,
        elRelative: null,
      },
      popupmessages: [],
      popupalerts: [],
      genericPopups: [],
      menubarReady: false,
      tabSelected: null,
      currentRoute: "",

      companyId: null,
      useEldaService: null,
      countryId: null,
      externalSoftware: null,
      employeeSyncSettingsArray: [],
    };
  },
  watch: {
    $route: {
      handler(newVal, oldVal) {
        if (newVal.path === oldVal.path) return;
        this.UpdateRoute(newVal);
      },
    },
    currentRoute(newVal, oldVal) {
      console.log("Current route changed from ", oldVal, " to ", newVal);
      if (!newVal || newVal === "") {
        this.UpdateRoute({ name: "landing", params: { tab: "LandingPage" } });
      }
      if (!this.isSuperUser && newVal === "superadmin") {
        this.UpdateRoute({ name: "landing", params: { tab: "LandingPage" } });
      }
      if (newVal && this.tabs[newVal] && (!this.tabs[newVal].find((t) => t.selected) || (this.tabs[newVal].find((t) => t.selected) && this.tabs[newVal].find((t) => t.selected).hidden))) {
        if (this.tabs[newVal].find((t) => t.selected)) {
          this.tabs[newVal].find((t) => t.selected).selected = false;
        }
        let firstTab = this.tabs[newVal].filter(f => !f.hidden)[0];
        if (firstTab) {
          this.UpdateSelectedView(firstTab);
        }
      }
    },
  },
  computed: {
    ...mapGetters(["isSuperUser"]),
    tabs() {
      let tabs = {
        documents: [
            {
                label: this.$t('global.ui.employee'),
                view: "employeedata",
                selected: this.tabSelected && this.tabSelected.view === "employeedata",
                margin: true,
            },
            {
                label: this.$t('settings.ui.templates'),
                view: 'documenttemplates',
                selected: this.tabSelected && this.tabSelected.view === "documenttemplates",
                margin: true,
            },/*
               {
                 label: "Datenabfragen",
                 view: "datainquiries",
                 selected: false,
                 margin: true,
               },*/
          /*{label: 'Duplikat Bereinigung', view: 'EmployeeDuplicateCleanup', selected: false, margin: true},*/
          /*{label: 'BMD-ID Import', view: 'BMDIDImport', selected: false, margin: true},*/
            {
                label: this.$t('settings.ui.importJobs'),
                view: 'EmployeeImportJobs',
                selected: this.tabSelected && this.tabSelected.view === "EmployeeImportJobs",
                margin: true,
            },
            {
                label: this.$t('settings.ui.export'),
                view: 'EmployeeExportOverview',
                selected: this.tabSelected && this.tabSelected.view === "EmployeeExportOverview",
                margin: true,
                hidden: this.externalSoftware !== 0, // only show EmployeeExportOverview when BMD Export is active
            },
            {
                label: this.$t('settings.ui.collectiveAgreements'),
                view: 'collectiveAgreements',
                selected: this.tabSelected && this.tabSelected.view === "collectiveAgreements",
                margin: true,
            },
            {
                label: this.$t('settings.ui.socialInsuranceReports'),
                view: 'EmployeeSocialInsuranceRegistrationOverview',
                selected: this.tabSelected && this.tabSelected.view === "EmployeeSocialInsuranceRegistrationOverview",
                margin: true,
                hidden: !(this.useEldaService && [0,1].includes(this.countryId)),
            }
        ],
        absence: [
            {
                label: this.$t('settings.ui.monthlySums'),
                view: 'ExportMonthly',
                selected: this.tabSelected && this.tabSelected.view === "ExportMonthly",
                margin: true,
                hidden: this.externalSoftware !== 0, // only show ExportMonthly when BMD Export is active
            },
            {
                label: this.$t('settings.ui.absences'),
                view: 'ExportDaily',
                selected: this.tabSelected && this.tabSelected.view === "ExportDaily",
                margin: true,
                hidden: this.externalSoftware !== 0 && ![54].includes(this.companyId), // only show ExportDaily when BMD Export is active or company is McDonald's Franchise GmbH (companyId: 54)
            },
            {
                label: this.$t('settings.ui.provisions'),
                view: 'ExportPersonnelProvisions',
                selected: this.tabSelected && this.tabSelected.view === "ExportPersonnelProvisions",
                margin: true,
                hidden: this.externalSoftware !== 0, // only show ExportPersonnelProvisions when BMD Export is active
            },
            {
                label: this.$t('settings.ui.punchTimes'),
                view: 'ExportDailyActualShifts',
                selected: this.tabSelected && this.tabSelected.view === "ExportDailyActualShifts",
                margin: true,
                hidden: ![54].includes(this.companyId), // only show ExportDailyActualShifts when company is McDonald's Franchise GmbH (companyId: 54)
            },
            {
                label: this.$t('settings.ui.datev'),
                view: 'ExportSotecDashboard',
                selected: this.tabSelected && this.tabSelected.view === "ExportSotecDashboard",
                margin: true,
                hidden: ![2,3,4,5,6].includes(this.externalSoftware),
            },
            {
                label: this.$t('settings.ui.individualWageTypesExport'),
                view: 'ExportIndividualWageTypes',
                selected: this.tabSelected && this.tabSelected.view === "ExportIndividualWageTypes",
                margin: true,
                hidden: false,
            },
            {
                label: this.$t('settings.ui.employeeExits'),
                view: 'ExportEmployeeExits',
                selected: this.tabSelected && this.tabSelected.view === "ExportEmployeeExits",
                margin: true,
                hidden: this.externalSoftware !== 0, // only show ExportEmployeeExits when BMD Export is active
            },
            {
                label: this.$t('settings.ui.slovenianParttime'),
                view: 'ExportSlovenianParttime',
                selected: this.tabSelected && this.tabSelected.view === "ExportSlovenianParttime",
                margin: true,
                hidden: this.externalSoftware !== 7,
            },
            {
                label: this.$t('settings.ui.slovenianPensioners'),
                view: 'ExportSlovenianPensioners',
                selected: this.tabSelected && this.tabSelected.view === "ExportSlovenianPensioners",
                margin: true,
                hidden: this.externalSoftware !== 7,
            },
            {
              label: this.$t('settings.ui.shiftBookings'),
              view: "ExportDpwShiftData",
              selected: this.tabSelected && this.tabSelected.view === "ExportDpwShiftData",
              margin: true,
              hidden: this.externalSoftware !== 1, // only show ExportDpwShiftData when DPW Export is active
            },
        ],
        comparison: [
            {
                label: this.$t('settings.ui.holiday'),
                view: 'ComparisonHoliday',
                selected: this.tabSelected && this.tabSelected.view === "ComparisonHoliday",
                margin: true,
                hidden: false,
            },
        ],
        company: [
            {
                label: this.$t('global.ui.settings'),
                view: "CompanySettings",
                selected: this.tabSelected && this.tabSelected.view === "CompanySettings",
                margin: true,
            },
            {
                label: this.$t('global.ui.notifications'),
                view: "NotificationOverview",
                selected: this.tabSelected && this.tabSelected.view === "NotificationOverview",
                margin: true,
            },
            {
                label: this.$t('settings.ui.roles'),
                view: "UserRoles",
                selected: this.tabSelected && this.tabSelected.view === "UserRoles",
                margin: true,
            },
            {
                label: this.$t('settings.ui.employeeSync'),
                view: 'EmployeeSyncSettings',
                selected: this.tabSelected && this.tabSelected.view === "EmployeeSyncSettings",
                margin: true,
                hidden: !this.employeeSyncSettingsArray.includes(this.externalSoftware), // only show EmployeeSyncSettings when there are sync settings for the current software
            },
            {
                label: this.$t('settings.ui.costCenters'),
                view: 'CostCenters',
                selected: this.tabSelected && this.tabSelected.view === "CostCenters",
                margin: true,
            },
            {
                label: this.$t('settings.ui.wageTypeMapping'),
                view: 'WageTypes',
                selected: this.tabSelected && this.tabSelected.view === "WageTypes",
                margin: true,
                hidden: this.externalSoftware !== 0, // only show WageTypes when BMD Export is active
            },
            {
                label: this.$t('settings.ui.employmentModels'),
                view: 'EmploymentModels',
                selected: this.tabSelected && this.tabSelected.view === "EmploymentModels",
                margin: true,
                hidden: false,
            },
            {
                label: this.$t('settings.ui.individualWageTypes'),
                view: 'IndividualWageTypes',
                selected: this.tabSelected && this.tabSelected.view === "IndividualWageTypes",
                margin: true,
                hidden: false,
            },
            {
                label: this.$t('settings.ui.averages'),
                view: 'AverageValues',
                selected: this.tabSelected && this.tabSelected.view === "AverageValues",
                margin: true,
                hidden: ![2,3,4,5,6].includes(this.externalSoftware),
            },
        ],
        reports: [
            {
                label: this.$t('settings.ui.reportAbsences'),
                view: 'ReportAbsences',
                selected: this.tabSelected && this.tabSelected.view === "ReportAbsences",
                margin: true,
                hidden: ![
                  "30", // Mustermann GmbH
                  "116", // Willy Dany
                  "154",  // Gerd Vogel
                  "161",  // Michael Betzien Systemgastronomie eK
                  "168", // Marcus kleine Burgerstube
                  "170", // Mike Kraft
                  "173", // Andreas Schoft
                  "175", // Blumroth
                  "176", // Kraft Systemgastronomie
                  "180", // Fietz Sievershabgen
                  "181", // Fietz Kröpeliner Straße
                  "182", // Fietz Schwerin
                  "183", // Fietz Wismar
                  "184", // Fietz Bentwisch

                  //"198", // Reisert
                  "199", // Michael Gollor
                  //"200" // Beer
                  "206",
                  "207" // Hendrix
                ].includes(""+this.companyId), // hide ReportAbsences for specific companies
            },
            {
                label: this.$t('settings.ui.reportOverview'),
                view: 'ReportOverview',
                selected: this.tabSelected && this.tabSelected.view === "ReportOverview",
                margin: true,
                hidden: ![
                  "30", // Mustermann GmbH
                  "116", // Willy Dany
                  "154",  // Gerd Vogel
                  "161",  // Michael Betzien Systemgastronomie eK
                  "168", // Marcus kleine Burgerstube
                  "170", // Mike Kraft
                  "173", // Andreas Schoft
                  "175", // Blumroth
                  "176", // Kraft Systemgastronomie
                  "180", // Fietz Sievershabgen
                  "181", // Fietz Kröpeliner Straße
                  "182", // Fietz Schwerin
                  "183", // Fietz Wismar
                  "184", // Fietz Bentwisch

                  //"198", // Reisert
                  "199", // Michael Gollor
                  //"200" // Beer
                  "206",
                  "207" // Hendrix
                ].includes(""+this.companyId), // hide ReportOverview for specific companies
            },
            {
                label: this.$t('settings.ui.reportOverviewVariable'),
                view: 'ReportOverviewVariable',
                selected: this.tabSelected && this.tabSelected.view === "ReportOverviewVariable",
                margin: true,
                hidden: false,
            },
            {
                label: this.$t('settings.ui.ksQuantityReport'),
                view: 'ReportBmdExportSums',
                selected: this.tabSelected && this.tabSelected.view === "ReportBmdExportSums",
                margin: true,
                hidden: this.externalSoftware !== 0, // only show ReportBmdExportSums when BMD Export is active
            },
            {
                label: this.$t('settings.ui.employeeCrossLocation'),
                view: 'ReportEmployeeCrossLocation',
                selected: this.tabSelected && this.tabSelected.view === "ReportEmployeeCrossLocation",
                margin: true,
                hidden: false,
            },
            {
                label: this.$t('settings.ui.employeeOverview'),
                view: 'ReportEmployeeOverview',
                selected: this.tabSelected && this.tabSelected.view === "ReportEmployeeOverview",
                margin: true,
                hidden: false,
            },
            {
                label: this.$t('settings.ui.reportAbsencesOverview'),
                view: 'ReportAbsencesOverview',
                selected: this.tabSelected && this.tabSelected.view === "ReportAbsencesOverview",
                margin: true,
                hidden: false,
            }
        ],
        landing: [
          {
            label: "Landing",
            view: "LandingPage",
            selected: true,
            margin: true,
            hidden: true,
          },
        ],
        superadmin: [
          {
            label: "Version",
            view: "SuperadminVersions",
            selected: this.tabSelected && this.tabSelected.view === "SuperadminVersions",
            margin: true,
            width: 100,
          },
          {
            label: "New Employees",
            view: "SuperadminNewEmployeeMail",
            selected: this.tabSelected && this.tabSelected.view === "SuperadminNewEmployeeMail",
            margin: true,
            width: 100,
          },
          {
            label: "Company",
            view: "SuperadminCompany",
            selected: this.tabSelected && this.tabSelected.view === "SuperadminCompany",
            margin: true,
            width: 100,
          },
          {
            label: "Store",
            view: "SuperadminStore",
            selected: this.tabSelected && this.tabSelected.view === "SuperadminStore",
            margin: true,
            width: 100,
          },
          {
            label: "Employee",
            view: "SuperadminEmployee",
            selected: this.tabSelected && this.tabSelected.view === "SuperadminEmployee",
            margin: true,
            width: 100,
          },
          {
            label: "Enums",
            view: "SuperadminEnums",
            selected: this.tabSelected && this.tabSelected.view === "SuperadminEnums",
            margin: true,
            width: 100,
          },
          {
            label: "LV Tools",
            view: "SuperadminExternalSoftware",
            selected: this.tabSelected && this.tabSelected.view === "SuperadminExternalSoftware",
            margin: true,
            width: 100,
          },
          {
            label: "Employee Sync",
            view: "SuperadminEmployeeSyncSettings",
            selected: this.tabSelected && this.tabSelected.view === "SuperadminEmployeeSyncSettings",
            margin: true,
            width: 100,
          },
          {
            label: "Transfer Service",
            view: "SuperadminTransferService",
            selected: this.tabSelected && this.tabSelected.view === "SuperadminTransferService",
            margin: true,
            width: 100,
          },
          {
            label: "ÖGK Clearing Meldungen",
            view: "EldaClearingOverview",
            selected: this.tabSelected && this.tabSelected.view === "EldaClearingOverview",
            margin: true,
            width: 100,
          },
          {
            label: this.$t('employee.collective.collectiveAgreements'),
            view: "SuperadminCollectiveAgreements",
            selected: this.tabSelected && this.tabSelected.view === "SuperadminCollectiveAgreements",
            margin: true,
            width: 100,
          },
        ],
      };
      return tabs;
    }
  },
  created() {
    window.app = this;
    document.body.addEventListener("mousemove", this.WatchMouse);
    document.body.addEventListener("mousemove", this.MouseMoveSubscriptionHandler);
    document.body.addEventListener("mousedown", this.WatchMouse);
    document.body.addEventListener("mouseup", this.WatchMouse);
    document.addEventListener("touchstart", this.TouchEventToMouseEvent, {
      passive: false,
    });
    document.addEventListener("touchmove", this.TouchEventToMouseEvent, {
      passive: false,
    });
    document.addEventListener("touchend", this.TouchEventToMouseEvent, {
      passive: false,
    });
    document.addEventListener("touchcancel", this.TouchEventToMouseEvent, {
      passive: false,
    });
    window.mouse = { x: 0, y: 0, click: false, element: {} };
  },
  mounted() {
    this.UpdateRoute(this.$route);
  },
  methods: {
    UpdateRoute(route) {
      console.log("Route: ", route);
      Object.values(this.tabs).forEach((t) => t.forEach((t2) => (t2.selected = false)));
      this.currentRoute = route.name;
      if (this.tabs[route.name]) {
        if (route.params.tab) {
          this.tabSelected = this.tabs[route.name].find((t) => t.view === route.params.tab);
          if (this.tabSelected != undefined && this.tabSelected.hidden) this.tabSelected = this.tabs[route.name].filter(t => !t.hidden)[0];
          if (this.tabSelected == undefined) this.tabSelected = this.tabs[route.name][0];
        } else {
          this.tabSelected = this.tabs[route.name].filter(t => !t.hidden)[0];
        }
        this.tabSelected.selected = true;
      } else {
        this.UpdateRoute({ name: "landing", params: { tab: "LandingPage" } });
      }
      if (window.menubar && window.menubar.$forceUpdate) window.menubar.$forceUpdate();
    },
    UpdateSelectedView(tab) {
      this.tabSelected = tab;
      this.$router.push({ name: this.currentRoute, params: { tab: tab.view } });
    },
    MouseMoveSubscribe(key, subscribeFunction) {
      this.mouseMoveSubscriptions[key] = subscribeFunction;
    },
    MouseMoveUnsubscribe(key) {
      delete this.mouseMoveSubscriptions[key];
    },
    MouseMoveSubscriptionHandler($event) {
      for (let x in this.mouseMoveSubscriptions) {
        this.mouseMoveSubscriptions[x](window.mouse.element);
      }
    },
    ToggleTooltip(element, state) {
      let nstate = { tooltip: true, elRelative: element, ...state };
      if (!nstate.pointerDirection) nstate.pointerDirection = 2;
      if (!nstate.pinBottomRight && !nstate.pinBottomLeft && !nstate.pinTopRight && !nstate.pinTopLeft) nstate.pinBottom = true;
      if (!nstate.offsety) nstate.offsety = 5;
      if (!nstate.offsetx) nstate.offsetx = 0;
      nstate.posx = window.mouse.x;
      nstate.posy = window.mouse.y;
      this.tooltipState = nstate;
      if (!nstate.pinBottom) this.tooltipState.pinBottom = false;
      if (!nstate.pinBottomLeft) this.tooltipState.pinBottomLeft = false;
      if (!nstate.pinBottomRight) this.tooltipState.pinBottomRight = false;
      if (!nstate.pinTopRight) this.tooltipState.pinTopRight = false;
      if (!nstate.pinTopLeft) this.tooltipState.pinTopLeft = false;
    },
    RepositionTooltip() {
      let view = this;
      this.$refs.tooltip.Reposition();
    },
    CheckDropdownContainers(dropdowncontainer) {
      let view = this;
      if (this.$children.filter((c) => view.genericPopups.find((g) => c.state === g)).every((c) => !c.toggled)) view.genericPopups = [];
    },
    TouchEventToMouseEvent($event) {
      var touches = $event.changedTouches,
        first = touches[0],
        type = "";
      switch ($event.type) {
        case "touchstart":
          type = "mousedown";
          break;
        case "touchmove": {
          if (window.roster && window.roster.dayMode) $event.preventDefault();
          type = "mousemove";
          break;
        }
        case "touchend":
          type = "mouseup";
          break;
        default:
          return;
      }

      var simulatedEvent = document.createEvent("MouseEvent");
      simulatedEvent.initMouseEvent(type, true, true, window, 1, first.screenX, first.screenY, first.clientX, first.clientY, false, false, false, false, 0 /*left*/, null);

      first.target.dispatchEvent(simulatedEvent);
      //$event.preventDefault();
    },
    WatchMouse($event) {
      if ($event.type === "mousedown" && $event.which === 1) window.mouse.click = true;
      if ($event.type === "mouseup" && $event.which === 1) window.mouse.click = false;
      if ($event.type === "mousemove") {
        window.mouse.x = $event.clientX;
        window.mouse.y = $event.clientY;
        window.mouse.element = document.elementFromPoint($event.clientX, $event.clientY);
      }
    },
    setCompanyId: function(companyId){
      let view = this;
      view.companyId = companyId;
    },
    setUseEldaService: function(useEldaService){
      let view = this;
      view.useEldaService = useEldaService;
    },
    setCountryId: function(countryId){
      let view = this;
      view.countryId = countryId;
    },
    setExternalSoftware: function(externalSoftware) {
      let view = this;
      view.externalSoftware = externalSoftware;
    },
    setEmployeeSyncSettingsArray: function(employeeSyncSettingsArray) {
      let view = this;
      view.employeeSyncSettingsArray = employeeSyncSettingsArray;
      console.log("Employee Sync Settings Array set in App.vue: ", employeeSyncSettingsArray);
    },
  },
};
</script>

<style>
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

.fullwidth {
  max-width: 100% !important;
}
/*
 * General styles
 */
body {
  /*background-repeat: no-repeat;
    background-image: linear-gradient(rgb(255, 255, 255), rgb(122, 144, 6));*/
  /*background-image: url("./assets/connectwork.png")*/
  background-color: whitesmoke;
}

.card-container.card {
  max-width: 100%;
  padding: 40px 40px;
}

.btn {
  font-weight: 700;
  height: 36px;
  -moz-user-select: none;
  -webkit-user-select: none;
  user-select: none;
  cursor: default;
}

/*
 * Card component
 */
.card {
  background-color: #f7f7f7;
  /* just in case there no content*/
  padding: 20px 25px 30px;
  margin: 0 auto 25px;
  margin-top: 50px;
  /* shadows and rounded borders */
  -moz-border-radius: 2px;
  -webkit-border-radius: 2px;
  border-radius: 2px;
  -moz-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
}

.profile-img-card {
  width: 96px;
  height: 96px;
  margin: 0 auto 10px;
  display: block;
  /*-moz-border-radius: 50%;
    -webkit-border-radius: 50%;
    border-radius: 50%;*/
}

/*
 * Form styles
 */
.profile-name-card {
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  margin: 10px 0 0;
  min-height: 1em;
}

.reauth-email {
  display: block;
  color: #404040;
  line-height: 2;
  margin-bottom: 10px;
  font-size: 14px;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.form-signin #inputEmail,
.form-signin #inputPassword {
  direction: ltr;
  height: 44px;
  font-size: 16px;
}

.form-signin input[type="email"],
.form-signin input[type="password"],
.form-signin input[type="text"] .form-signin input[type="number"],
.form-signin button {
  width: 100%;
  display: block;
  margin-bottom: 10px;
  z-index: 1;
  position: relative;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.form-signin .form-control:focus {
  border-color: rgb(104, 145, 162);
  outline: 0;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgb(104, 145, 162);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgb(104, 145, 162);
}

.btn.btn-signin {
  /*background-color: #4d90fe; */
  background-color: rgb(104, 145, 162);
  /* background-color: linear-gradient(rgb(104, 145, 162), rgb(12, 97, 33));*/

  font-weight: 700;
  font-size: 14px;
  height: 36px;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  border: none;
  -o-transition: all 0.218s;
  -moz-transition: all 0.218s;
  -webkit-transition: all 0.218s;
  transition: all 0.218s;
}

.btn.btn-signin:hover,
.btn.btn-signin:active,
.btn.btn-signin:focus {
  background-color: rgb(122, 144, 6);
}

.forgot-password {
  color: rgb(104, 145, 162);
}

.forgot-password:hover,
.forgot-password:active,
.forgot-password:focus {
  color: rgb(12, 97, 33);
}
.custom-dialog div {
  box-sizing: border-box;
}
.custom-dialog .dialog-flex {
  width: 100%;
  height: 100%;
}
.custom-dialog .dialog-content {
  flex: 1 0 auto;
  width: 100%;
  padding: 15px;
  font-size: 14px;
}
.custom-dialog .dialog-c-title {
  font-weight: 600;
  padding-bottom: 15px;
}
.custom-dialog .dialog-c-text {
}
.custom-dialog .custom-dialog-buttons {
  display: flex;
  flex: 0 1 auto;
  width: 100%;
  border-top: 1px solid #eee;
}
.custom-dialog .custom-dialog-buttons-none {
  width: 100%;
  padding-bottom: 15px;
}
.custom-dialog-button {
  font-size: 12px !important;
  background: transparent;
  padding: 0;
  margin: 0;
  border: 0;
  cursor: pointer;
  box-sizing: border-box;
  line-height: 40px;
  height: 40px;
  color: inherit;
  font: inherit;
  outline: none;
}
.custom-dialog-button:hover {
  background: rgba(0, 0, 0, 0.01);
}
.custom-dialog-button:active {
  background: rgba(0, 0, 0, 0.025);
}
.custom-dialog-button:not(:first-of-type) {
  border-left: 1px solid #eee;
}
</style>

<style>
@import "./assets/styles/colors_dark.css";
@import "./assets/styles/colors_light.css";
@import "./assets/styles/md.css";
@import "./assets/styles/fontawesome.css";
@import "./assets/styles/md_750px.css";
@import "./assets/styles/md_1380px.css";
@import "./assets/styles/dropdown.css";
@import "./assets/styles/bootstrap.css";
@import "./assets/styles/bootstrap-vue.css";
@import "./assets/styles/all.min.css";

.component-container {
  position: absolute;
  top: 90px !important;
  left: 0;
  width: 100%;
  height: calc(100vh - 90px) !important;
  overflow-x: auto;
  overflow-y: auto;
}

.component-container.full-height {
  top: -7px !important;
  left: 0;
  width: 100%;
  height: calc(100vh - 55px) !important;
}
</style>
